<ds-error-message [errorList]="errorList"></ds-error-message>
<div class="replace-vehicle year-make-model">
  <form [formGroup]="yearMakeModelForm" (ngSubmit)="submit()">
    <div class="row">
      <div class="column twelve flex items-center pad-bottom-20">
        <span class="icon-info pad-right-10 warning-yellow-text"></span>Enter VIN and Year for the
        most accurate quote.
      </div>
      <div class="column twelve md-six">
        <ds-form-control-container
          [labelText]="'Vehicle Year'"
          [control]="yearMakeModelForm.controls['year']"
        >
          <select id="year" class="icon fill" formControlName="year">
            <option value="unset" selected disabled>Select a vehicle year</option>
            @for (year of years; track year) {
              <option [value]="year">{{ year }}</option>
            }
          </select>
          <span
            [ngClass]="
              (loading | async) && currentLoad === 'year' ? 'input-loader' : 'icon-chevron-down'
            "
          ></span>
          <ds-form-control-message
            [control]="yearMakeModelForm.controls['year']"
          ></ds-form-control-message>
        </ds-form-control-container>
      </div>
    </div>

    <div class="row margin-top-10">
      <div class="column twelve md-six">
        @if (makes?.length > 0) {
          <ds-form-control-container
            [labelText]="'Vehicle Make'"
            [control]="yearMakeModelForm.controls['make']"
          >
            <select id="make" class="icon fill" formControlName="make">
              <option value="unset" selected disabled>Select a vehicle make</option>
              @for (make of makes; track make) {
                <option [value]="make">{{ make }}</option>
              }
            </select>
            <span
              [ngClass]="
                (loading | async) && currentLoad === 'make' ? 'input-loader' : 'icon-chevron-down'
              "
            ></span>
            <ds-form-control-message
              [control]="yearMakeModelForm.controls['make']"
            ></ds-form-control-message>
          </ds-form-control-container>
        }
      </div>
    </div>

    <div class="row margin-top-10">
      <div class="column twelve md-six">
        @if (models?.length > 0) {
          <ds-form-control-container
            [labelText]="'Vehicle Model'"
            [control]="yearMakeModelForm.controls['model']"
          >
            <select id="model" class="icon fill" formControlName="model">
              <option value="unset" selected disabled>Select a vehicle model</option>
              @for (model of models; track model) {
                <option [value]="model">{{ model }}</option>
              }
            </select>
            <span
              [ngClass]="
                (loading | async) && currentLoad === 'model' ? 'input-loader' : 'icon-chevron-down'
              "
            ></span>
            <ds-form-control-message
              [control]="yearMakeModelForm.controls['model']"
            ></ds-form-control-message>
          </ds-form-control-container>
        }
      </div>
    </div>

    <div class="row margin-top-10">
      <div class="column twelve md-six">
        @if (styles?.length > 0) {
          <ds-form-control-container
            [labelText]="'Vehicle Style'"
            [control]="yearMakeModelForm.controls['style']"
          >
            <select id="style" class="icon fill" formControlName="style">
              <option value="unset" selected disabled>Select a vehicle style</option>
              @for (style of styles; track style) {
                <option [value]="style">{{ style }}</option>
              }
            </select>
            <span
              [ngClass]="
                (loading | async) && currentLoad === 'style' ? 'input-loader' : 'icon-chevron-down'
              "
            ></span>
            <ds-form-control-message
              [control]="yearMakeModelForm.controls['style']"
            ></ds-form-control-message>
          </ds-form-control-container>
        }
      </div>
    </div>

    @if (hasError | async) {
      <div class="error-600-text caption">{{ errorMessage }}</div>
    }

    <div class="row pad-top-20">
      <div class="column twelve">
        Did you know your policy includes new vehicle coverage for
        {{ gracePeriodDays$ | async }} days from the purchase date?
        <a href="javascript:void(0)" (click)="toggleGracePeriod()">More details.</a>
      </div>
    </div>

    <div class="row callToAction">
      <div class="column twelve">
        <span class="md-float-right">
          <a
            class="pad-horizontal-20"
            (click)="cancel()"
            dsContent
            [contentPath]="'shared.cancel'"
          ></a>
          <button
            ds-button
            type="submit"
            [disabled]="
              !yearMakeModelForm.valid ||
              !yearMakeModelForm.dirty ||
              (loading | async) ||
              !(roleService.isAuthorized('replacevehiclequote_submit') | async)
            "
          >
            @if (!(loading | async)) {
              <span>Next</span>
            }
            @if (loading | async) {
              <span>Loading...</span>
            }
          </button>
        </span>
      </div>
    </div>
  </form>
</div>
<ds-grace-period
  [gracePeriodDays]="gracePeriodDays$ | async"
  [(visible)]="displayPolicyGracePeriod"
  [activeAgents]="activeAgents$ | async"
  [user]="userState$ | async"
></ds-grace-period>
